<div id="content">
  <button [hidden]="selectedLocation.length === 0" class="inventorybutton" (click) = "setInventory()"
  [ngStyle]="{'background-color': getInventoryColor(), 'border': 'solid 2px ' + getInventoryColor()}" >{{getInventoryTitle()}}</button>
  <div id="subContent"  [style.marginTop.px] = '(selectedLocation.length === 0) ? 40 : 0'>
    <div id="columnLeft">
      <div id="dataContainer">
        <h1 i18n="@@warehouses.data">Dane magazynu:</h1>
        <ul id="menu">
          <li>
            <a class="label" i18n="@@warehouses.warehouse">Magazyn:</a>
            <div class="selectContainer">
              <mat-select class = "locSelector" width='30%' [(ngModel)]="selectedLocation"  (selectionChange)="locationChanged($event.value)">
                  <mat-option class = "selectLocOpt" *ngFor="let loc of locations | keyvalue" [value]="loc.value.NAME">{{loc.value.NAME}}</mat-option>
              </mat-select >
            </div>
            <hr>
          </li>
          <li>
            <a class="label" i18n="@@warehouses.adress">Adress:</a>
            <a class="value">{{locAddress}}</a>
            <hr>
          </li>
          <li>
            <a class="label" i18n="@@warehouses.size">Wielkość:</a>
            <a class="value">{{locSize}}</a>
            <hr>
          </li>
          <li>
            <a class="label" i18n="@@warehouses.occupancy">Zajętość:</a>
            <a class="value">t.b.d</a>
            <hr>
          </li>
        </ul>
      </div>

      <div id="spacer">
      </div>

      <div id="inventoryContainer">
        <h1 i18n="@@warehouses.inventoryStatus">Status inwentaryzacji</h1>

        <ul id="menu">
          <li>
            <a class="label" i18n="@@warehouses.statusTitle">Status:</a>
            <a class="value">{{locInventoryStatus}}</a>
            <hr>
          </li>
          <li>
            <a class="label" i18n="@@warehouses.lastInventory">Ostatnia inwentaryzacja</a>
            <a class="value">{{locInventoryDate}}</a>
            <hr>
          </li>
        </ul>
      </div>

    </div>

    <div id="columnRight">

      <div id="chartContainer">
        <h1 i18n="@@warehouses.warehouses">Magazyny</h1>
        <app-piechart [pieChartData]="chartValues"  [pieChartLabels]="chartLabels" [pieChartType]="'pie'" (clicked)="onClicked($event)" ></app-piechart>
      </div>
      <div id="warehouseList" style="overflow-x:auto;">
        <table style="width:100%">
          <thead>
            <tr>
              <th [hidden]="getType() === 'commercial'" i18n="@@warehouses.desc">Opis</th>
              <th [hidden]="getType() !== 'commercial'" i18n="@@warehouses.name">Nazwa</th>
              <th>UID</th>
              <th i18n="@@warehouses.status">Status</th>
            </tr>
          </thead>
            <tbody>
              <tr id="itemsTable" *ngFor = "let item of items" (click)="listItemClicked(item.ID)" >
                <td [hidden]="getType() === 'commercial'">{{item.Desription}}</td>
                <td [hidden]="getType() !== 'commercial'">{{item.Title}}</td>
                <td>{{item.ID}}</td>
                <td id="tdCenter" appStatusinfo status="{{item.Status}}"></td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
  </div>
</div>
